import React, { forwardRef } from 'react'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import useStyles from './useStyles'

interface Props {
  width?: number | string
  height?: number | string
  margin?: number | string
  error?: boolean
  className?: React.ComponentProps<typeof OutlinedInput>['className']
  classes?: React.ComponentProps<typeof OutlinedInput>['classes']
  [key: string]: unknown
}

const Input: React.FC<Props> = forwardRef(({ height, width, margin, className = '', error, ...restProps }, ref) => {
  const classes = useStyles({ height, margin })

  return (
    <OutlinedInput
      {...restProps}
      style={{
        ...(width && { width }),
        ...(height && { height }),
      }}
      error={error}
      className={`${classes.container} ${className}`}
      inputRef={ref}
    />
  )
})

Input.displayName = 'input'
export default Input
